import React from 'react';
import {Dialog,DialogTitle,DialogContent,DialogActions,Typography,IconButton,Button,TextField} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const GenerateInviteSuccessfully = ({
  open,
  onClose,
  generatedInvite,
  copiedInviteUrl,
  copyToClipboard
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiPaper-root': { fontSize: '10.5px' },
        '& .MuiTypography-root': { fontSize: '10.5px' },
        '& .MuiDialogTitle-root': { fontSize: '10.5px', fontWeight: 600 },
        '& .MuiButton-root': { fontSize: '10.5px' },
        '& .MuiInputBase-input': { fontSize: '10.5px' },
      }}
    >
      <DialogTitle className="position-relative">
        Interview Invite Generated
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="position-absolute top-0 end-0 m-2 text-secondary"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography gutterBottom>
          Share this link with the candidate to start their interview:
        </Typography>

        <div className="d-flex align-items-center gap-2 bg-light rounded p-2 mt-2">
          <TextField
            value={generatedInvite?.interviewUrl || ''}
            fullWidth
            InputProps={{
              readOnly: true,
              disableUnderline: true,
              className: 'bg-transparent border-0'
            }}
            variant="standard"
          />
          <Button
            variant="contained"
            onClick={() => copyToClipboard(generatedInvite.interviewUrl)}
          >
            {copiedInviteUrl === generatedInvite.interviewUrl ? 'Copied!' : 'Copy'}
          </Button>
        </div>

        <Typography variant="body2" className="text-muted mt-3">
          Note: This link can only be used once. Once the candidate starts the interview,
          the link will become invalid.
        </Typography>
      </DialogContent>

      <DialogActions className="justify-content-center">
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateInviteSuccessfully;
